export const SkillsData = [
  {
    type: "AI & Machine Learning",
    skills: [
      "Salesforce Agentforce",
      "HuggingFace Transformers",
      "Agent Script Development",
      "Prompt Engineering",
      "LLM Steering & Fine-tuning (LoRA)",
      "RAG (Retrieval-Augmented Generation)",
      "Reranking & Cache-Augmented Generation",
      "Time-Series Forecasting (ARIMA, Prophet, LightGBM)",
      "Transformer Architectures & Training Dynamics",
      "Multi-Agent Orchestration (LangGraph, Google ADK)",
      "AI Harness Engineering (guardrails, HITL, observability)",
      "KV Caching & Inference Optimisation",
      "Pydantic Runtime Validation",
      "AWS Bedrock",
      "SageMaker Studio"
    ]
  },
  {
    type: "Hardware & Embedded",
    skills: [
      "ESP32-S3 / ESP-IDF",
      "MicroPython",
      "iCE40 FPGA (yosys, nextpnr)",
      "RTL Simulation (tiny-gpu)",
      "Verilog / ISA Design",
      "Edge Inference"
    ]
  },
  {
    type: "Programming Languages",
    skills: [
      "Python",
      "JavaScript/TypeScript",
      "Apex",
      "SOQL/SOSL",
      "SQL",
      "HTML/CSS"
    ]
  },
  {
    type: "Cloud & DevOps",
    skills: [
      "AWS",
      "Google Cloud Platform (GCP)",
      "Model Context Protocol (MCP)",
      "Kubernetes",
      "Docker",
      "GitLab CI/CD",
      "n8n Automation",
      "Vibe Coding Tools"
    ]
  },
  {
    type: "Salesforce Platform",
    skills: [
      "Salesforce Service Cloud",
      "Lightning Web Components (LWC)",
      "Apex Development",
      "Agentforce Implementation",
      "Agent Script",
      "Experience Cloud",
      "Omni-Channel",
      "Salesforce DX (SFDX)",
      "Flow Builder"
    ]
  },
  {
    type: "Web & Full-Stack Development",
    skills: [
      "MERN Stack",
      "React/Next.js",
      "Node.js/Express",
      "MongoDB",
      "REST/GraphQL APIs",
      "Material-UI",
      "Tailwind CSS"
    ]
  }
];